<template>
  <div class="no_user_container">
    <img src="@/assets/img/no_user.svg" alt="" />
    账号异常，请联系管理员！
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.no_user_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  width: 100%;
  height: 100vh;
  text-align: center;
  caret-color: transparent;
  color: #79a4e9;
  font-size: 18px;
  font-weight: 500;
  img {
    margin-bottom: 12px;
  }
}
</style>